export default __webpack_public_path__ + "static/media/merge.2be2c388.svg";